import { useEffect } from 'react';

import { isEmpty } from 'ramda';

import i18n, { loadTranslations } from 'i18n';
import logger from 'utils/logger';

export const useLoadTranslations = () => {
  useEffect(() => {
    const loadLocales = async () => {
      await loadTranslations(i18n);
    };

    if (isEmpty(i18n.availableLocales)) {
      loadLocales().catch(logger.error);
    }
  }, []);
};
